<script setup>
import licenseTypeOptions from '@/views/ad-account-requests/white-lists/components/licenseTypeOptions'
import FileUpload from '@shared-components/ui/inputs/files/FileUpload.vue'
import TheSelect from '@shared-components/ui/selects/TheSelect.vue'
import {defineEmits, defineModel, defineProps, ref} from 'vue'
import {openUrl} from '@shared/utils/helpers'
import TheCopyInputButton from '@shared-components/ui/buttons/TheCopyInputButton.vue'

const modelFile = defineModel('modelFile', {required: true})
const modelLink = defineModel('modelLink', {required: true, type: String})

// Props & emits
const emit = defineEmits(['file-uploaded'])
const props = defineProps({
  label: {
    type: String,
    default: 'Label',
    required: true,
  },
  usageType: {
    type: String,
    default: 'file',
  },
  loading: {
    type: Boolean,
    default: null,
  },
  required: {
    type: Boolean,
    default: false,
  },
  id: {
    type: String,
    default: 'upload-document',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  documentType: {
    type: String,
    default: 'file',
  },
  hideTools: {
    type: Boolean,
    default: false,
  },
  hint: {
    type: String,
    default: '',
  },
})

// Refs
const documentType = ref(props.documentType)

// Methods
const resetDocumentData = () => {
  modelFile.value = {hash: '', name: '', file_url: ''}
  modelLink.value = undefined
}
const onFileUploaded = file => {
  emit('file-uploaded', file)
}
</script>

<template>
  <div class="alert alert-light">
    <label :for="`${id}-${documentType}`"> {{ label }} <span v-if="required">*</span></label>
    <div class="row">
      <div class="col">
        <div v-if="documentType === 'file'" class="form-group">
          <file-upload
            v-model="modelFile"
            :disabled="loading || disabled"
            :can-edit="!modelFile?.hash"
            @file-uploaded="onFileUploaded"
            :usage-type="usageType"
            :hide-tools="hideTools"
            :id="`${id}-file`"
            :required="required"
            :is-object-assign-file="false"
          />
        </div>
        <div v-else class="form-group">
          <div class="input-group">
            <input
              v-model="modelLink"
              type="url"
              placeholder="Add link"
              class="form-control"
              :id="`${id}-link`"
              :disabled="loading || disabled"
              :required="required"
            />
            <span v-if="modelLink" class="input-group-text gap-2">
              <the-copy-input-button :value="modelLink" :id="`${id}-link-copy`" />

              <span
                class="open-in-new-tab-btn clickable-icon"
                @click.prevent="openUrl(modelLink)"
                v-tooltip="'Open in a new tab'"
              >
                <i class="fa-solid fa-link" />
              </span>
            </span>
          </div>
        </div>
      </div>
      <div v-if="!disabled" class="col-3 pl-0">
        <the-select
          v-model="documentType"
          :options="licenseTypeOptions"
          @change="resetDocumentData"
          placeholder=""
          :disabled="loading"
          :allow_clear="false"
          :can_deselect="false"
        />
      </div>
    </div>
    <div v-if="props.hint" class="mt-2">
      <small>{{ props.hint }}</small>
    </div>
  </div>
</template>
